import React, { memo } from 'react';

import { HamburgerIcon } from '../../../';

import classes from './HamburgerButton.module.scss';

const HamburgerButton = ({ onClick }) => {
  return (
    <div onClick={onClick} className={classes.HamburgerButton}>
      <HamburgerIcon className={classes.Icon} />
    </div>
  );
};

export default memo(HamburgerButton);
